<template>
    <nav class="navbar default-layout-navbar col-lg-3 col-3 p-0 d-flex flex-row" :class="user.candidate_id === null && navPosition == 'bottom-left' ? 'fixed-top' : 'fixed-top-right'">

        <div v-if="showLockedScreen" class="membership-locked-content">
            <app-icon :name="'unlock'" width="40" height="40"/><br>
            <div class="offset-md-3 col-md-6">
                <h5><b>{{ this.lockedScreenText }}</b></h5><br>
                {{ $t('plan_expired') }}<br><br>
            </div>

            <a href="?pay=1" class="btn btn-primary mt-2">{{ $t('trial_period_ended_buy_button') }}</a>

        </div>

        <div class="navbar-menu-wrapper d-flex align-items-stretch">

            <div class="d-flex justify-content-between w-100">


                <div v-if="this.user.candidate_id === null" class="d-flex justify-content-start">
                     <button class="navbar-toggler align-self-center d-none d-lg-block pl-0"
                            type="button">
                    <span v-if="leftMenuType === 'normal'"
                              :key="'align-center'"
                              @click.prevent="togglingLeftMenu('active-icon-only-menu', 'permanently')"
                              :title="$t('floating_sidebar')">
                        <app-icon :name="'align-justify'"/>
                    </span>
                    <span v-else-if="leftMenuType === 'icon-only'"
                                :key="'align-center'"
                                @click.prevent="togglingLeftMenu('active-normal-menu', 'permanently')"
                                :title="$t('floating_sidebar')">
                        <app-icon :name="'align-justify'"/>
                    </span>
                    <span v-else-if="leftMenuType === 'floating'"
                              :key="'align-justify'"
                              @click.prevent="togglingLeftMenu('active-floating-menu', 'permanently')"
                              :title="$t('full_sidebar')">
                        <app-icon :name="'align-justify'"/>
                    </span>
                    </button>



                    <button class="navbar-toggler align-self-center d-lg-none pl-0"
                            type="button"
                            data-toggle="offcanvas"
                            @click="sidebarOffcanvas">
                        <app-icon :name="'align-left'"/>
                    </button>
                    <slot name="left-option"></slot>
                </div>
                <div class="d-flex justify-content-center">
                    <slot name="center-option"></slot>
                </div>




                <div class="navbar-actions-right">
                    <ul class="navbar-nav navbar-nav-right ml-auto">

                        <app-guide v-if="user.candidate_id === null && navPosition == 'bottom-left'"></app-guide>

                        <app-navbar-settings-dropdown v-if="user.candidate_id === null && navPosition == 'bottom-left'" :data="settingsData"/>

                        <!--

                        <li class="nav-item d-none d-lg-block">
                            <a v-if="fullScreen" class="d-flex align-items-center nav-link" href="#" :key="'maximize'"
                               @click="fullscreen" :title="$t('exit_fullscreen')">
                                <app-icon :name="'minimize'"/>
                            </a>
                            <a v-else class="d-flex align-items-center nav-link" href="#" :key="'minimize'" @click="fullscreen"
                               :title="$t('fullscreen')">
                                <app-icon :name="'maximize'"/>
                            </a>
                        </li>

                        <app-navbar-language-dropdown :selected-language="selectedLanguage" :data="languageData"/>
-->

                        <li v-if="navPosition == 'top-right'" class="nav-item nav-profile dropdown nav-my-account nav-my-account-top-right user-profile-name">{{ this.user.first_name }}</li>
                        <app-navbar-notification-dropdown v-if="user.candidate_id === null && navPosition == 'bottom-left'" :all-notification-url="allNotificationUrl" :data="notificationData" :show-identifier="showIdentifier" @clicked="sendNotification"/>

                        <app-navbar-profile-dropdown :user="user" :data="profileData" :class="navPosition == 'bottom-left' ? 'nav-my-account' : 'nav-my-account nav-my-account-top-right'" />
                    </ul>
                </div>
            </div>
        </div>

    </nav>
</template>

<script>
    import ThemeMixin from "../../mixins/global/ThemeMixin";
    import * as actions from "../../../app/Config/ApiUrl";
    import CoreLibrary from "../../helpers/CoreLibrary";
    import AppFunction from "../../helpers/app/AppFunction";

    export default {
        name: "Navbar",
        mixins: [ThemeMixin],
        extends: CoreLibrary,
        props: {
            user: {
                type: Object,
                require: true
            },
            permission: {
                type: Object,
                require: true
            },
            selectedLanguage: {
                type: String,
                default: 'CS'
            },
            languageData: {
                type: Array,
                require: true
            },
            notificationData: {
                type: Array,
                require: true
            },
            logoUrl: {
                type: String,
                default: AppFunction.getAppUrl('images/core.png'),
            },
            allNotificationUrl: {
                type: String,
                require: true
            },
            showIdentifier: {
                type: Boolean,
                default: false
            }

        },
        data() {
            return {
                fullScreen: false,
                leftMenuType: 'normal',
                navPosition: 'bottom-left',
                darkMode: false,
                showMenu: true,
                membershipData: [],
                showLockedScreen: false,
                menuTemporary: false,
                settingsData: [
                    {
                        optionName: this.$t('careers'),
                        optionIcon: 'briefcase',
                        url: '../jobs',
                        permission: 'view_career',
                    },
                    {
                        optionName: this.$t('user_role'),
                        optionIcon: 'user',
                        url: actions.USERS_AND_ROLES
                    },
                    {
                        optionName: this.$t('advert_templates'),
                        optionIcon: 'edit',
                        url: '../'+actions.DATATABLE_CAREERS_TEMPLATE_URL,
                        permission: 'view_hiring',
                    },
                    {
                        optionName: this.$t('mail_templates'),
                        optionIcon: 'mail',
                        url: '../'+actions.DATATABLE_MAIL_TEMPLATES_URL,
                        permission: 'view_hiring',
                    },
                    {
                        optionName: this.$t('settings'),
                        optionIcon: 'tool',
                        url: actions.APP_SETTINGS
                    },
                    // {
                    //     optionName: this.$t('subscription'),
                    //     optionIcon: 'credit-card',
                    //     url: '?pay=1'
                    // },
                ],
                profileData: [
                    {
                        optionName: this.$t('my_profile'),
                        optionIcon: 'user',
                        url: actions.MY_PROFILE
                    },

                    {
                        optionName: this.$t('support'),
                        optionIcon: 'help-circle',
                        target: '_blank',
                        url: 'https://onboardio.cz/kontakt.html'
                    },

                    {
                        optionName: this.$t('log_out'),
                        optionIcon: 'log-out',
                        url: actions.LOGOUT
                    },
                ],
            }
        },
        watch: {
            leftMenuType: function () {
                let htmlElement = document.documentElement;

                if (this.leftMenuType === 'normal') {
                    if(!this.menuTemporary){
                        localStorage.setItem('sidebar', 'normal');
                    }

                    htmlElement.setAttribute('sidebar', 'normal');
                } else if (this.leftMenuType === 'icon-only') {
                    if(!this.menuTemporary){
                        localStorage.setItem('sidebar', 'icon-only');
                    }

                    htmlElement.setAttribute('sidebar', 'icon-only');
                } else {
                    if(!this.menuTemporary){
                        localStorage.setItem('sidebar', 'floating');
                    }

                    htmlElement.setAttribute('sidebar', 'floating');
                }
            },
            user: function(newVal, oldVal) {
                if(newVal){
                    this.checkPermissions();
                }
            }
        },
        mounted() {
            // Check for active theme
            let body = $('body'),
                htmlElement = document.documentElement,
                theme = localStorage.getItem('theme'),
                sidebar = localStorage.getItem('sidebar');

            if (theme === 'dark') {
                htmlElement.setAttribute('theme', 'dark');
                this.darkMode = true;
                this.$store.state.theme.darkMode = true;
            } else {
                htmlElement.setAttribute('theme', 'light');
                this.darkMode = false;
                this.$store.state.theme.darkMode = false;
            }

            if(location.pathname.includes("/employee/")){
                htmlElement.setAttribute('theme', 'light');
                this.darkMode = false;
                this.$store.state.theme.darkMode = false;
                this.navPosition = "top-right";
            }

            if (sidebar === 'normal') {
                localStorage.setItem("sidebar", 'normal');
                htmlElement.setAttribute('sidebar', 'normal');
                body.removeClass('sidebar-icon-only');
                body.removeClass('sidebar-hover-only');
                this.leftMenuType = 'normal';
            } else if (sidebar === 'icon-only') {
                localStorage.setItem("sidebar", 'icon-only');
                htmlElement.setAttribute('sidebar', 'icon-only');
                body.removeClass('sidebar-hover-only');
                body.toggleClass('sidebar-icon-only');
                this.leftMenuType = 'icon-only';
            } else if (sidebar === 'floating') {
                localStorage.setItem("sidebar", 'floating');
                htmlElement.setAttribute('sidebar', 'floating');
                body.removeClass('sidebar-icon-only');
                body.toggleClass('sidebar-hover-only');
                $('.sidebar').find('.collapse.show').collapse('hide');
                this.leftMenuType = 'floating';
            }


            if(window.location.href.indexOf("admin") > -1){
                $('#onboarding.collapse').collapse('show');
            }

            if(window.location.href.indexOf("employee") > -1 && this.showMenu){
                this.togglingLeftMenu('active-floating-menu', 'temporary');
            }
            if(window.location.href.indexOf("employee") > -1){

            }

            let _this = this;
            $( "#sidebar" ).click(function() {
                if(window.location.href.indexOf("employee") > -1){
                    _this.togglingLeftMenu('active-normal-menu', 'temporary');
                }
            });

            $( "#sidebar" ).hover(function() {
                if(!$('#onboarding').hasClass('show') && !$('#hiring').hasClass('show')){
                    if(window.location.href.indexOf("onboarding") > -1 || window.location.href.indexOf("employee") > -1){
                        $('#onboarding.collapse').collapse('show');
                        $('#hiring.collapse').collapse('hide');
                    } else if(window.location.href.indexOf("hiring") > -1 || window.location.href.indexOf("talentpool") > -1 || window.location.href.indexOf("jobs") > -1 || window.location.href.indexOf("careersite") > -1){
                        $('#hiring.collapse').collapse('show');
                        $('#onboarding.collapse').collapse('hide');
                    }
                }
                $('.sidebar .nav').show();

            });

            $( ".navbar" ).click(function() {
                if(window.location.href.indexOf("onboarding") > -1 || window.location.href.indexOf("employee") > -1){
                    $('#onboarding.collapse').collapse('show');
                    $('#hiring.collapse').collapse('hide');
                } else if(window.location.href.indexOf("hiring") > -1 || window.location.href.indexOf("talentpool") > -1 || window.location.href.indexOf("jobs") > -1 || window.location.href.indexOf("careersite") > -1){
                    $('#hiring.collapse').collapse('show');
                    $('#onboarding.collapse').collapse('hide');
                }
            });

            //this.isMembershipPaid();

        },
        methods: {
            checkPermissions(){
                if(this.user.roles[0].id == 5){
                    this.showMenu = false;
                } else if(window.innerWidth > 989) {
                    setTimeout(function(){
                        $('.sidebar-hover-only .navbar').css('pointer-events','none');
                        $('.sidebar-hover-only .navbar-actions-right').css('pointer-events','all');
                        $('.sidebar-hover-only .nav').hide();
                    }, 500);
                }
            },
            sendNotification(notification) {
                this.$emit('clicked', notification);
            },
            sidebarOffcanvas() {
                $('.sidebar-offcanvas').toggleClass('active')
            },
            fullscreen() {
                if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
                    if (document.documentElement.requestFullScreen) {
                        document.documentElement.requestFullScreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (document.documentElement.webkitRequestFullScreen) {
                        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                    } else if (document.documentElement.msRequestFullscreen) {
                        document.documentElement.msRequestFullscreen();
                    }
                    this.fullScreen = true;
                } else {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                    this.fullScreen = false;
                }
            },
            togglingLeftMenu(action, save) {
                let body = $('body');

                if(save === 'temporary'){
                    this.menuTemporary = true;
                } else {
                    this.menuTemporary = false;
                }

                if (action === 'active-icon-only-menu') {
                    body.removeClass('sidebar-hover-only');
                    body.toggleClass('sidebar-icon-only');
                    $('.sidebar').find('.collapse').removeClass('collapse');
                    this.leftMenuType = 'icon-only';


                } else if (action === 'active-floating-menu') {
                    body.removeClass('sidebar-icon-only');
                    body.toggleClass('sidebar-hover-only');
                    $('.sidebar').find('.collapse.show').collapse('hide');
                    this.leftMenuType = 'floating';

                } else if (action === 'active-normal-menu') {
                    body.removeClass('sidebar-icon-only');
                    body.removeClass('sidebar-hover-only');
                    this.leftMenuType = 'normal';

                }
            },

            /**
            * Membership
            */
            isMembershipPaid() {
                this.trialMode = true;
                this.daysRemaining = 30;

                // Get date to and count remaining days
                let url = actions.MEMBERSHIP;

                this.axiosGet(url).then(response => {

                    var membershipData = response.data;
                    let paidUntil = '';
                    let trialUntil = '';
                    let todaysDateRaw = new Date();
                    let todaysDate = new Date();

                    if(membershipData[0].paid_until !== null){
                         paidUntil = new Date(membershipData[0].paid_until.replace(/-/g, "/"));
                    }

                    if(membershipData[0].trial_until !== null){
                         trialUntil = new Date(membershipData[0].trial_until.replace(/-/g, "/"));
                    }

                    let isMembershipPaid = paidUntil > todaysDate ? true : false;
                    let isTrialActive = trialUntil > todaysDate ? true : false;
                    let trialLeft = moment(trialUntil).diff(moment(todaysDateRaw), 'days')+1;

                    if(paidUntil != "" && !isMembershipPaid){
                        $('body>div:eq(0)>div:eq(0)').find('.content-wrapper').append('<div class="trial-note text-center note note-silver pt-5 pb-5 mt-4 row"><div class="col-sm-12 offset-md-3 col-md-6"><b>'+this.$t('last_days_of_your_trial_first_part')+' '+trialLeft+' '+this.$t('last_days_of_your_trial')+'</b><br>Vyberte si balíček ať můžete Onboardio nadále využívat.</div><div class="col-sm-12 col-md-3 text-center"><a href="?pay=1" class="ml-md-3 ml-sm-0 mb-sm-4 mb-md-0 mt-2 mt-md-0 btn btn-primary">'+this.$t('buy_onboardio')+'</a></div></div>');

                        if(membershipData[0].paid_until){
                            this.lockedScreenText = 'Vaše členství vypršelo';
                        } else {
                            this.lockedScreenText = 'Zkušební verze již vypršela';
                        }
                        $('body').addClass('membership-locked');
                        this.showLockedScreen = true;

                    } else if (trialUntil != "" && !isTrialActive){
                        $('body>div:eq(0)>div:eq(0)').find('.content-wrapper').append('<div class="trial-note text-center note note-silver pt-5 pb-5 mt-4 row"><div class="col-sm-12 offset-md-3 col-md-6"><b>'+this.$t('last_days_of_your_trial_first_part')+' '+trialLeft+' '+this.$t('last_days_of_your_trial')+'</b><br>Vyberte si balíček ať můžete Onboardio využívat i po uplynutí zkušební doby.</div><div class="col-sm-12 col-md-3 text-center"><a href="?pay=1" class="ml-md-3 ml-sm-0 mb-sm-4 mb-md-0 mt-2 mt-md-0 btn btn-primary">'+this.$t('buy_onboardio')+'</a></div></div>');

                        if(membershipData[0].paid_until){
                            this.lockedScreenText = 'Vaše členství vypršelo';
                        } else {
                            this.lockedScreenText = 'Zkušební verze již vypršela';
                        }
                        $('body').addClass('membership-locked');
                        this.showLockedScreen = true;

                    }

                }).catch(({response}) => {

                }).finally(() => {

                });

            },

        }
    }
</script>
